// Static data used across the app. Kept module-level so references are stable.
import {
  ThumbsUp,
  ThumbsDown,
  Share2,
  Repeat2,
  Flag,
  Lock,
  UserRoundX,
  Languages,
  BrainCircuit,
  ShieldCheck,
  Megaphone,
} from "lucide-react";

export const TOPICS = [
  { slug: "omosessualita-lgbtq", title: "Omosessualità e LGBTQ+", image: "https://images.unsplash.com/photo-1561612217-e5147162fd31?w=800&h=500&fit=crop", tint: ["#f97316", "#ec4899", "#8b5cf6"] },
  { slug: "politicamente-corretto", title: "Politicamente corretto", image: "/topics/politicamente-corretto.jpg", tint: ["#d9302a", "#374151"] },
  { slug: "remigrazione", title: "Remigrazione", image: "https://images.unsplash.com/photo-1632560917731-d8a3b5120869?w=800&h=500&fit=crop", tint: ["#6b7280", "#9ca3af"] },
  { slug: "politica", title: "Politica", image: "https://images.unsplash.com/photo-1748194380219-846a1c4bd2f0?w=800&h=500&fit=crop", tint: ["#a8a29e", "#78716c"] },
  { slug: "emergenza-maranza", title: "Emergenza Maranza", image: "https://images.unsplash.com/photo-1519501025264-65ba15a82390?w=800&h=500&fit=crop", tint: ["#292524", "#57534e"] },
  { slug: "magistratura", title: "Magistratura", image: "https://images.unsplash.com/photo-1589994965851-a8f479c573a9?w=800&h=500&fit=crop", tint: ["#78716c", "#a8a29e"] },
  { slug: "comunismo-fascismo", title: "Comunismo e Fascismo", image: "https://images.unsplash.com/photo-1511898634545-c01af8a54dd5?w=800&h=500&fit=crop", tint: ["#dc2626", "#1c1917"] },
  { slug: "islam-cristianesimo", title: "Islam e Cristianesimo", image: "https://images.unsplash.com/photo-1519817650390-64a93db51149?w=800&h=500&fit=crop", tint: ["#404040", "#6b7280"] },
  { slug: "sport", title: "Sport", image: "/topics/sport.jpg", tint: ["#0f766e", "#14b8a6"] },
  { slug: "attualita", title: "Attualità", image: "/topics/attualita.jpg", tint: ["#9a6700", "#d4a017"] },
];

export const POST_ACTIONS = [
  { key: "like", label: "Mi piace", icon: ThumbsUp, testable: true, iconOnly: true },
  { key: "dislike", label: "Non mi piace", icon: ThumbsDown, testable: true, iconOnly: true },
  { key: "share", label: "Condividi", icon: Share2 },
  { key: "diffuse", label: "Diffondi", icon: Repeat2 },
  { key: "report", label: "Segnala", icon: Flag },
  { key: "dm", label: "Messaggio privato", icon: Lock },
];

export const FEED_TABS = [
  { key: "recenti", label: "Recenti" },
  { key: "seguiti", label: "Persone che seguo" },
  { key: "discussi", label: "Più discussi" },
  { key: "apprezzati", label: "Più apprezzati" },
];

export const PROFILE_TABS = [
  { key: "posts", label: "I miei post", active: true },
  { key: "media", label: "Media", active: false },
  { key: "likes", label: "Mi piace", active: false },
];

export const FOOTER_VALUES = [
  { key: "age", i: "18+", label: "18+", color: "primary", anchor: "value-age" },
  { key: "pseudonimo", i: UserRoundX, label: "Pseudonimo", color: "dark", anchor: "value-pseudonimo" },
  { key: "multilingue", i: Languages, label: "Multilingue", color: "dark", anchor: "value-multilingue" },
  { key: "moderazione", i: BrainCircuit, label: "Moderazione AI", color: "dark", anchor: "value-moderazione" },
  { key: "video", i: ShieldCheck, label: "Video protetti", color: "dark", anchor: "value-video" },
  { key: "pubblicita", i: Megaphone, label: "Gratis con pubblicità", color: "primary", anchor: "value-pubblicita" },
];

// Explanatory content shown as anchored sections on the home page. Each
// footer badge scrolls to the matching card, so users understand exactly
// what the icon represents.
export const VALUE_SECTIONS = [
  {
    anchor: "value-age",
    icon: "age",
    title: "Solo maggiorenni (18+)",
    body: "L'accesso è riservato a utenti di età pari o superiore a 18 anni. La conferma dell'età avviene al primo ingresso ed è memorizzata sul tuo dispositivo.",
  },
  {
    anchor: "value-pseudonimo",
    icon: "pseudonimo",
    title: "Identità pseudonima",
    body: "Nessuna email o numero di telefono. Ogni account è protetto da 12 parole BIP39 e da una chiave crittografica Ed25519 generate localmente. La tua identità reale non è mai esposta.",
  },
  {
    anchor: "value-multilingue",
    icon: "multilingue",
    title: "Multilingue",
    body: "L'interfaccia e i contenuti supportano più lingue: puoi ascoltare messaggi in italiano, inglese, spagnolo e altre. La lingua del post è visibile per aiutarti a scegliere cosa aprire.",
  },
  {
    anchor: "value-moderazione",
    icon: "moderazione",
    title: "Moderazione AI soft",
    body: "Nessuno shadowban: contenuti a rischio vengono revisionati da un modello di moderazione, poi da moderatori umani. Se un tuo post viene sanzionato ricevi la motivazione e puoi presentare ricorso.",
  },
  {
    anchor: "value-video",
    icon: "video",
    title: "Video protetti",
    body: "I media allegati alle richieste di messaggio privato sono sfocati fino all'accettazione della richiesta. Il download di un audio o video privato è possibile solo se l'autore lo concede esplicitamente.",
  },
  {
    anchor: "value-pubblicita",
    icon: "pubblicita",
    title: "Gratis con pubblicità",
    body: "L'app è completamente gratuita: la sostenibilità è garantita da banner silenziosi. Ogni banner può essere chiuso con la × per sostituirlo con quello successivo — nessun tracker pubblicitario.",
  },
];
